var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgYoutube = function SvgYoutube(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.22 15.061a2.709 2.709 0 00-1.885-1.937C27.167 12.804 20 13 20 13s-7 0-8.335.124a2.709 2.709 0 00-1.886 1.937c-.446 1.708-.446 5.272-.446 5.272s0 3.564.446 5.273a2.709 2.709 0 001.886 1.936C13.33 28 20 28 20 28s6.671 0 8.335-.458a2.71 2.71 0 001.886-1.936c.446-1.709.446-5.273.446-5.273s0-3.564-.446-5.272z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24v-7l6 3.5-6 3.5z",
    fill: "red"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube.597c7d6c0f87a7bc11e4ae3b04dd0687.svg";